import { Products } from "./products";

export function Home() {

  return (
    <>
    <Products/>
    </>
  );
}
